export const getEnvVariable = (varName: string) => {
  const value = process.env[varName];

  if (typeof value === "undefined") {
    throw new Error(`Environment variable undefined: ${varName}`);
  }

  return value;
};
